/**
 * @owner @Appboy/user-targeting
 */
import type { AllRouteEndpoints } from "../routeTypes";

export const engagementApiSegmentCohortsBillingHistory = "/engagement/api/segment_cohorts/billing_history";
export const engagementApiSegmentCohortsBillingHistoryCacheKeys: AllRouteEndpoints[] = [
  "/engagement/api/segment_cohorts/billing_history",
];
